import FormattedContent from "@/components/content-block/text/formatted-content/index";

export default {
  props: ["content"],
  components: { FormattedContent },
  computed: {
    segments() {
      if (this.content.segments) {
        return this.content.segments;
      }

      return [this.content];
    },
  },
};
